import React from 'react'
import Touchable from '@sport1/news-styleguide/Touchable'
import NonFlexingContainer from '@sport1/news-styleguide/NonFlexingContainer'
import SummaryDropupButton from '@sport1/news-styleguide/SummaryDropupButton'
import SummaryDropdownButton from '@sport1/news-styleguide/SummaryDropdownButton'

type LivetickerSummaryButtonProps = {
    onPress: () => void
    buttonType: 'up' | 'down'
}

const LivetickerSummaryButton = ({ buttonType, onPress }: LivetickerSummaryButtonProps) => (
    <NonFlexingContainer
        width="100%"
        centerHorizontal
        position="relative"
        backgroundColor="red"
        zIndex={3}
        paddingX="auto"
    >
        <NonFlexingContainer zIndex={3} position="absolute" bottom={-10}>
            <Touchable onPress={onPress} testID="liveticker-summary-button-touchable">
                {buttonType === 'up' ? (
                    <SummaryDropupButton testID="dropup-button" />
                ) : (
                    <SummaryDropdownButton testID="dropdown-button" />
                )}
            </Touchable>
        </NonFlexingContainer>
    </NonFlexingContainer>
)

export default LivetickerSummaryButton
